(() => {
  'use strict';
  const configElement = document.getElementById('BoxyLocalizationConfig');
  const form = document.getElementById('BoxyAutoLocalization');
  if (!configElement || !form || window.Shopify?.designMode) return;
  const config = JSON.parse(configElement.textContent);
  const checkedCookie = 'boxy_localization_checked';
  const manualCookie = 'boxy_localization_manual';
  const hasCookie = name => document.cookie.split(';').some(value => value.trim().startsWith(`${name}=`));
  const remember = (name, persistent = false) => {
    document.cookie = `${name}=1; Path=/; SameSite=Lax; Secure${persistent ? '; Max-Age=31536000' : ''}`;
  };
  const isLocalizationForm = element => element instanceof HTMLFormElement &&
    element !== form && element.querySelector('[name="form_type"][value="localization"]');
  const manualChoice = () => remember(manualCookie, true);

  // Capture native selectors too: Horizon submits some forms with form.submit().
  document.addEventListener('change', event => {
    if (['language_code', 'locale_code', 'country_code'].includes(event.target.name) &&
        isLocalizationForm(event.target.form)) manualChoice();
  }, true);
  document.addEventListener('click', event => {
    const country = event.target.closest?.('localization-form-component .localization-form__list-item[data-value]');
    if (country) manualChoice();
  }, true);
  document.addEventListener('submit', event => {
    if (isLocalizationForm(event.target)) manualChoice();
  }, true);
  document.addEventListener('formdata', event => {
    if (isLocalizationForm(event.target)) manualChoice();
  }, true);

  if (!config.detect || hasCookie(manualCookie) || hasCookie(checkedCookie) ||
      /bot\b|crawler|spider|lighthouse|google-inspection/i.test(navigator.userAgent)) return;

  const url = new URL(location.href);
  const firstSegment = url.pathname.split('/').filter(Boolean)[0]?.toLowerCase();
  const rootSegment = config.root.split('/').filter(Boolean)[0]?.toLowerCase();
  const explicitLanguage = config.languages.some(language => language.toLowerCase() === firstSegment) ||
    Boolean(rootSegment && rootSegment === firstSegment);
  let internalNavigation = false;
  try { internalNavigation = new URL(document.referrer).origin === location.origin; } catch (_) { /* No referrer. */ }
  // A language-specific link and a customer's navigation take precedence over detection.
  const preserveLanguage = explicitLanguage || internalNavigation || url.searchParams.has('locale');
  const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
  const availableLanguage = value => config.languages.find(item => item.toLowerCase() === value);
  const matchBrowserLanguage = value => {
    const tag = value.replace(/_/g, '-').toLowerCase();
    const exact = availableLanguage(tag);
    if (exact) return exact;
    // Shopify calls Traditional Chinese zh-TW; Hong Kong browsers commonly send zh-HK or zh-Hant-HK.
    if (/^(?:zh-(?:hant(?:-|$)|hk(?:-|$)|mo(?:-|$)|tw(?:-|$))|yue-(?:hant(?:-|$)|hk(?:-|$)))/.test(tag)) {
      return availableLanguage('zh-tw');
    }
    if (/^zh-hans(?:-|$)|^zh-(?:cn|sg)(?:-|$)/.test(tag)) {
      return availableLanguage('zh-cn');
    }
    return availableLanguage(tag.split('-')[0]);
  };
  let language = preserveLanguage ? config.language : browserLanguages
    .map(matchBrowserLanguage)
    .find(Boolean) || (config.languages.includes('en') ? 'en' : config.language);

  // Mark before the POST so a failed request or redirect cannot create a loop.
  remember(checkedCookie);
  if (!hasCookie(checkedCookie)) return;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 2000);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const endpoint = new URL(`${root}browsing_context_suggestions.json`, location.origin);
  endpoint.searchParams.set('country[enabled]', 'true');
  endpoint.searchParams.set('language[enabled]', 'true');

  (async () => {
    let country = config.country;
    try {
      if (!url.searchParams.has('country') && !internalNavigation) {
        const response = await fetch(endpoint, { signal: controller.signal, credentials: 'same-origin' });
        if (response.ok) {
          const suggestion = await response.json();
          const detected = suggestion.detected_values?.country?.handle;
          if (config.countries.includes(detected)) country = detected;
        }
      }
    } catch (_) { /* Browser language still works if country discovery is unavailable. */ }
    finally { clearTimeout(timeout); }

    const primaryBrowserLanguage = String(browserLanguages[0] || '').replace(/_/g, '-').toLowerCase();
    if (!preserveLanguage && ['TW', 'HK'].includes(country) && /^(zh|yue)$/.test(primaryBrowserLanguage)) {
      language = availableLanguage('zh-tw') || language;
    }

    // The customer may have used a selector while discovery was in flight.
    if (hasCookie(manualCookie) || (country === config.country && language === config.language)) return;
    form.elements.language_code.value = language;
    form.elements.country_code.value = country;
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    returnTo.value = `${location.pathname}${location.search}${location.hash}`;
    // Shopify resolves translated handles and applies the actual market currency.
    HTMLFormElement.prototype.submit.call(form);
  })();
})();
